import classNames from 'classnames';
import './squared-thumbnail.scss';

interface SquaredThumbnailProps {
  thumbnail?: string;
  className?: string;
  backgroundColor?: string;
}

export const SquaredThumbnail: React.FC<SquaredThumbnailProps> = ({
  thumbnail,
  children,
  className,
  backgroundColor = '#f4f7ff',
}) => {
  return (
    <div
      className={classNames(className, 'squared-thumbnail')}
      style={{
        background: `url('${thumbnail}') center center / cover no-repeat ${backgroundColor}`,
      }}
    >
      {children}
    </div>
  );
};
